import type { ResultSet } from 'react-native-sqlite-storage';

type SqliteRow = Record<string, any>;

export function mapResultRows<T>(
  result: ResultSet,
  mapper: (row: SqliteRow, index: number) => T
): T[] {
  const rows: T[] = [];

  for (let i = 0; i < result.rows.length; i++) {
    rows.push(mapper(result.rows.item(i), i));
  }

  return rows;
}

export function resultRowsToArray<T = SqliteRow>(result: ResultSet): T[] {
  return mapResultRows(result, (row) => row as T);
}

export function getFirstResultRow<T = SqliteRow>(result: ResultSet): T | null {
  if (result.rows.length === 0) {
    return null;
  }

  return result.rows.item(0) as T;
}
